import { Helpers } from '../../helpers';
import { IRegulatoryWellType } from '../../interfaces/iregulatory-well-type';
import { Well } from '../well';

export class RegulatoryWellTypeBase {
  RegulatoryWellTypeId: number;
  Description: string | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  Wells_RegulatoryWellType?: Array<Well> | null;

  constructor(item?: IRegulatoryWellType) {
    if (item) {

      this.RegulatoryWellTypeId = item.RegulatoryWellTypeId;
      this.Description = item.Description;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.Wells_RegulatoryWellType = Helpers.createClassArray(Well, item.Wells_RegulatoryWellType);
    }
  }
}